import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Input, Alert } from '@dreamtree-org/twreact-ui';
import { Handshake } from 'lucide-react';
import { errorText } from '@/lib/format';
import { useMutation } from '@/lib/useQuery';
import { useVendorSession } from '../VendorApp';

/** Vendor sign-in. Approved and pending vendors may sign in; pending ones see their status. */
export default function SignIn({ store }) {
  const { reload } = useVendorSession();
  const signIn = useMutation('vendorSignIn');
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signIn.run(form);
      reload();
    } catch (ex) {
      setError(errorText(ex));
    }
  };

  return (
    <VendorAuthFrame store={store} title="Vendor sign in" subtitle={`Sell your products on ${(store && store.name) || 'this store'}.`}>
      <form className="space-y-3" onSubmit={submit}>
        <Input label="Email" type="email" autoComplete="username" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
        <Input label="Password" type="password" autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
        <p className="text-sm text-right"><Link className="underline opacity-80" to="/forgot-password">Forgot password?</Link></p>
        {error ? <Alert variant="error" title="Could not sign in">{error}</Alert> : null}
        <Button type="submit" className="w-full" loading={signIn.loading}>Sign in</Button>
      </form>
      <p className="text-sm text-center opacity-80">New here? <Link className="font-medium underline" to="/apply">Apply to sell</Link></p>
    </VendorAuthFrame>
  );
}

/** The centred card the sign-in, apply and status screens share. */
export function VendorAuthFrame({ store, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[var(--app-bg)] flex items-center justify-center px-4 py-10">
      <Card className="w-full max-w-md p-6 space-y-5">
        <div className="space-y-1 text-center">
          <span className="inline-flex items-center gap-1 text-sm opacity-70"><Handshake size={16} aria-hidden /> {(store && store.name) || 'MerchantPro'} · Vendor portal</span>
          <h1 className="text-2xl font-bold">{title}</h1>
          {subtitle ? <p className="text-sm opacity-80">{subtitle}</p> : null}
        </div>
        {children}
      </Card>
    </div>
  );
}
